export function setRemInit() {
	// postcss-px2rem的内容
	// 基准大小
	// console.log(baseSize)
	// 设置 rem 函数
	function setRem() {
		const baseSize = document.documentElement.clientWidth > 980 ? 192 : 192;
		const scaleNum = document.documentElement.clientWidth > 980 ? 1920 : 750;
		// 当前页面宽度相对于 1920 px(设计稿尺寸)的缩放比例，可根据自己需要修改。
		const scale = document.documentElement.clientWidth / scaleNum;
		// const scale = window.screen.availWidth / 1920;
		// 设置页面根节点字体大小
		document.documentElement.style.fontSize = `${baseSize * scale}px`;
		window.app_scale = scale;
	}
	// 初始化
	setRem();
	// 改变窗口大小时重新设置 rem
	window.addEventListener('resize', setRem);
	setTimeout(function () {
		var size = document.documentElement.style.fontSize;
		if (!size)
			setRem()
	}, 750);
}


// WEBPACK FOOTER //
// ./src/rem.js